export enum OrdersColumnId {
  Hospital = 'hospital',
  OrderNumber = 'orderNumber',
  DeliveryNumber = 'deliveryNumber',
  SurgeryDate = 'surgeryDate',
  DueDate = 'dueDate',
  Status = 'status',
  Express = 'express',
  DeviceMissing = 'deviceMissing',
}
